import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold my-5" }, " languages ", -1)
const _hoisted_2 = { class: "space-y-4" }

import { ref } from 'vue'
import { useMainStore, useInterfaceLanguageStore } from '@/stores'
import { notify } from '@inriver/inri'
import { getErrorMessage } from '@inriver/inri/src/utils/errorUtils'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n()
const interfaceLanguageStore = useInterfaceLanguageStore()
const mainStore = useMainStore()

const interfaceLanguageCode = ref(mainStore.user.interfaceLanguageCode)
const dataLanguageCode = ref(mainStore.user.dataLanguageCode)
const modelLanguageCode = ref(mainStore.user.modelLanguageCode)

async function save () {
  try {
    await mainStore.updateLanguageCodes(interfaceLanguageCode.value, dataLanguageCode.value, modelLanguageCode.value)
    await interfaceLanguageStore.setLanguage(interfaceLanguageCode.value)
    notify.success(t('user.languages_updated'))
  } catch (error) {
    notify.error(getErrorMessage(error))
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_c_btn = _resolveComponent("c-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_select, _mergeProps({
        modelValue: interfaceLanguageCode.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((interfaceLanguageCode).value = $event))
      }, _ctx.$inri.inputDense, {
        label: _ctx.$t('user.interface_language'),
        options: _unref(mainStore).languages,
        "emit-value": "",
        "map-options": ""
      }), null, 16, ["modelValue", "label", "options"]),
      _createVNode(_component_q_select, _mergeProps({
        modelValue: dataLanguageCode.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dataLanguageCode).value = $event))
      }, _ctx.$inri.inputDense, {
        label: _ctx.$t('user.data_language'),
        options: _unref(mainStore).languages,
        "emit-value": "",
        "map-options": ""
      }), null, 16, ["modelValue", "label", "options"]),
      _createVNode(_component_q_select, _mergeProps({
        modelValue: modelLanguageCode.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelLanguageCode).value = $event))
      }, _ctx.$inri.inputDense, {
        label: _ctx.$t('user.model_language'),
        options: _unref(mainStore).languages,
        "emit-value": "",
        "map-options": ""
      }), null, 16, ["modelValue", "label", "options"])
    ]),
    _createVNode(_component_c_btn, {
      class: "my-8 w-full",
      onClick: save
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('inri.common.save')), 1)
      ]),
      _: 1
    })
  ], 64))
}
}

})